import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tab from '@mui/material/Tab';
import Tooltip from '@mui/material/Tooltip';
import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import '../../auth/propay-budget-detail.css';
import { convertNumber } from '../../components/fields';
import BonusCalculatorDetailPage from '../../dashboard/BonusCalculatorDetailPage';
import { FORECAST_TAB_ICON, OVERVIEW_TAB_ICON } from '../../utils/Constants/ClassName';
import { NUMBER } from '../../utils/Constants/MagicNumber';

const PropayActualAndTotalData = (props: any) => {
    const {maxHours, record, identity, workerPreview} = props;

    const [value, setValue] = useState(identity?.user_type === 'worker' ? 'Personal' : 'Team' );
    const employeeId = () => workerPreview.show ? workerPreview.employee_id : identity?.employee_id;
    const [personalDetail,setPersonalDetail] = useState((identity?.user_type === 'worker' || workerPreview.show ) ? record?.employee_wage_ids?.filter((item)=> item.employee_id === employeeId())[NUMBER.ZERO]
    : {performance_bonus:NUMBER.ZERO, attendance_earning:NUMBER.ZERO, hours:NUMBER.ZERO});

    useEffect(()=>{
        if(workerPreview?.show || identity?.user_type === 'worker'){
            setPersonalDetail(record?.employee_wage_ids?.filter((item)=> item.employee_id === employeeId())[NUMBER.ZERO]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[identity?.user_type,workerPreview?.show,workerPreview?.employee_id]);

    console.log(personalDetail, 'personalDetail')
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        });
        const calculateBasepay = () => {
            let bonusOnlyHours = NUMBER.ZERO;
            record?.wage_ids?.map((workerData) => {
                if(!workerData.is_remove_bonus)
                {
                 bonusOnlyHours = bonusOnlyHours + workerData.hours;
                }
            });
            return bonusOnlyHours;
        }
    const actualHoursForcalculation = calculateBasepay();
    const budget = record?.budget;
    const budgetHours = Number((maxHours*NUMBER.ONE).toFixed(NUMBER.TWO));
    const actualHours = Number((record?.hours*NUMBER.ONE).toFixed(NUMBER.TWO));
    const varianceAmount = ((record?.remaining_amount)*NUMBER.ONE).toFixed(NUMBER.TWO);
    const varianceHours = ((record?.remaining_hours)*NUMBER.ONE).toFixed(NUMBER.TWO);
    const actualAmount = record?.attendance_earning+Number(record?.ot_amt);
    const approvedBonus = record?.performance_bonus;
    const actualPercentComplete = `${(NUMBER.HUNDRED * (actualAmount / budget )) > NUMBER.ZERO ? (NUMBER.HUNDRED * (actualAmount / budget)).toFixed(NUMBER.TWO) : NUMBER.ZERO}%`
    const PercenatgeChange = (record.performance_bonus/actualAmount)* NUMBER.HUNDRED;
    const PerhourChange = actualHoursForcalculation ? record.performance_bonus/actualHoursForcalculation : NUMBER.ZERO;
    const translate = useTranslate();
    const [tab, setTab] = useState('Overview');

    const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
        setTab(newValue);
    };
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    const personalBonus = Number((personalDetail?.performance_bonus*NUMBER.ONE).toFixed(NUMBER.TWO));
    const personalActualBalance = Number((personalDetail?.attendance_earning*NUMBER.ONE).toFixed(NUMBER.TWO));
    const personalActualHours = Number((personalDetail?.hours*NUMBER.ONE).toFixed(NUMBER.TWO));
    const personalPercenatgeChange = Number(((personalDetail?.performance_bonus/personalDetail?.attendance_earning)* NUMBER.HUNDRED).toFixed(NUMBER.TWO));
    const personalPerhourChange = personalDetail?.hours ? Number((personalDetail?.performance_bonus/personalDetail?.hours).toFixed(NUMBER.TWO)) : NUMBER.ZERO;

     const workerPoolPercent = (record?.worker_bonus_percent*NUMBER.ONE).toFixed(NUMBER.TWO);
     const companyPoolPercent = (record?.company_bonus_percent*NUMBER.ONE).toFixed(NUMBER.TWO);
    //  const companyPool = ((Number(varianceAmount)*Number(companyPoolPercent))/100).toFixed(2);
    //  const workerPool = ((Number(varianceAmount)*Number(workerPoolPercent))/100).toFixed(2);

    return(
        <>
        <TabContext value={tab}>
            <TabList aria-label="Overview Forecast tabs example" onChange={handleChangeTab} className='overview-tabs-row'>
                <Tab icon={OVERVIEW_TAB_ICON()} label="Overview" value="Overview" />
                    {record?.employee_wage_ids?.length && ['pending', 'started', 'completed']?.includes(record?.status) && record?.employee_wage_ids?.some(wage => wage?.employee_id_obj) &&
                    <Tab icon={FORECAST_TAB_ICON()} label="Forecast" value="Forecast"  />}
                    {/* <Tab icon={BONUS_POOL_TAB_ICON()} label="Bonus Pool" value="Bonus Pool"  /> */}
            </TabList>
               <TabPanel value="Overview">
                    <TabContext value={value}>
                    <div className='overview-budget-box'>
                    <Box className='overview-new-tabs-row'>
                        {(identity?.user_type === 'worker' || workerPreview.show) && <TabList onChange={handleChange} aria-label="Personal Team tabs example" className='team-personal-tabs'>
                            <Tab label="Personal" value="Personal" />
                            <Tab label="Team" value="Team" />
                        </TabList>}
                    </Box>
                    <TabPanel value="Personal">
                        <div className="budget-detail-sec budget-new-overview remove-hyper-linking">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Hours</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='budget-headers'>Actuals</td>
                                        <td data-title="Hours">{convertNumber((personalActualHours), identity)}</td>
                                        <td data-title="Amount">{formatter.format(personalActualBalance ? personalActualBalance : 0)}</td>
                                    </tr>
                                    <tr>
                                        <td className='budget-headers'>Approved Bonuses
                                        {record?.bonus_split_type && <Tooltip arrow placement="top" title={translate(`resources.propays.bonus_choices.bonus_split_type.${record.bonus_split_type}.info`!)}>
                                            <IconButton>
                                            Split: {translate(`resources.propays.bonus_choices.bonus_split_type.${record.bonus_split_type}.label`!)}
                                            </IconButton>
                                        </Tooltip>}
                                        </td>
                                        <td className='hidden-td-mobile'>&nbsp;</td>
                                        <td data-title="Amount" className={`${Number(approvedBonus) < 0 ? 'red-text font-weight-700':''} ${Number(approvedBonus) > NUMBER.ZERO ? 'green-text font-weight-700':''}`}>
                                        <div className='approve-bonus-mobile'>
                                            {formatter.format(Number(personalBonus))}
                                        <span className='approve-bonus-value'>
                                            {record.bonus_split_type === 'by_hours' && <span className='text-green font-weight-700'>
                                            ({personalDetail.performance_bonus ? formatter.format(personalPerhourChange): formatter.format(NUMBER.ZERO)}/hr)</span>}
                                        {record.bonus_split_type === 'by_wage' && <span className='approve-bonus-text'>
                                            ({personalDetail.performance_bonus ? parseFloat(personalPercenatgeChange.toString()).toFixed(NUMBER.TWO): '0'}%)
                                            {personalDetail.performance_bonus ? <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                                            <path d="M1 6.5L6 1.5M6 1.5L11 6.5M6 1.5V13.5" stroke="#4FCA4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg> : ''}
                                            </span>}
                                        </span>
                                        </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </TabPanel>
                    <TabPanel value="Team">
                    <div className="budget-detail-sec budget-new-overview remove-hyper-linking">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Hours</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className='budget-headers'>
                                        <span className='budget-modal-text'>Budget</span>
                                            {record?.budget_option === 'amount' ? <LabelWithTooltip
                                            tooltipTitle='Completion is tracked against amount instead of hours. Hours will fluctuate based on the worker hours and their wage.'
                                             label='Fixed Amount'/> :
                                            <LabelWithTooltip
                                            tooltipTitle='Completion is tracked against hours instead of amount. Amount will fluctuate based on the worker hours and their wage.'
                                             label='Fixed Hours'/>}
                                            </td>
                                            <td data-title="Hours">{convertNumber((budgetHours), identity)}</td>
                                            <td data-title="Amount">{formatter.format(budget)}</td>
                                        </tr>
                                        <tr>
                                            <td className='budget-headers'>Actuals</td>
                                            <td data-title="Hours"><div className='actual-hour-value'>{convertNumber((actualHours), identity)}{record?.budget_option === 'hours' && <span className='hrs-overview-text' >(<p>{isFinite(parseFloat(actualPercentComplete)) ? actualPercentComplete : '0%' }</p> spent)</span>}</div></td>
                                            <td data-title="Amount"><div className='actual-hour-value'>{formatter.format(actualAmount ? actualAmount : 0)}{record?.budget_option === 'amount' && <span className='hrs-overview-text' >(<p>{isFinite(parseFloat(actualPercentComplete)) ? actualPercentComplete : '0%' }</p> spent)</span>}</div></td>
                                        </tr>
                                    <tr>
                                        <td className='budget-headers'>Variance</td>
                                        <td data-title="Hours" className={`${Number(varianceHours) > 0 ? 'text-green font-weight-700':''} ${Number(varianceHours) < 0 ? 'red-text font-weight-400':''}`}>{convertNumber((varianceHours), identity)}</td>
                                        <td data-title="Amount" className={`${Number(varianceAmount)> 0 ? 'text-green font-weight-700':''} ${Number(varianceAmount)< 0 ? 'red-text font-weight-400':''}`}>{formatter.format(Number(varianceAmount))}</td>
                                    </tr>
                                    {record?.is_bonus_pool_enabled && <><tr className='company-worker-pool-tr'>
                                                <td colSpan={2} className='hidden-td-mobile'>{identity?.company?.company_pool_label ? identity?.company?.company_pool_label : 'Company Pool'}</td>
                                                <td data-title={identity?.company?.company_pool_label ? identity?.company?.company_pool_label : 'Company Pool'}>{formatter.format(Number(record?.company_pool))} ({companyPoolPercent}%)</td>
                                        </tr>
                                        <tr className='company-worker-pool-tr'>
                                            <td colSpan={2} className='hidden-td-mobile'>{identity?.company?.worker_pool_label ? identity?.company?.worker_pool_label : 'Worker Pool'}</td>
                                            <td data-title={identity?.company?.worker_pool_label ? identity?.company?.worker_pool_label : 'Worker Pool'}>{formatter.format(Number(record?.worker_pool))} ({workerPoolPercent}%)</td>
                                        </tr>
                                        </>
                                        }
                                    <tr>
                                        <td className='budget-headers'>Approved Bonuses
                                        {record?.bonus_split_type && <Tooltip arrow placement="top" title={translate(`resources.propays.bonus_choices.bonus_split_type.${record.bonus_split_type}.info`!)}>
                                            <IconButton>
                                            Split: {translate(`resources.propays.bonus_choices.bonus_split_type.${record.bonus_split_type}.label`!)}
                                            </IconButton>
                                        </Tooltip>}
                                        </td>
                                        <td className='hidden-td-mobile'>&nbsp;</td>
                                        <td data-title="Amount" className={`${Number(approvedBonus) < 0 ? 'red-text font-weight-700':''} ${Number(approvedBonus) > NUMBER.ZERO ? 'green-text font-weight-700':''}`}>
                                        <div className='approve-bonus-mobile'>
                                            {formatter.format(Number(approvedBonus))}
                                        <span className='approve-bonus-value'>
                                            {record.bonus_split_type === 'by_hours' && <span className='text-green font-weight-700'>
                                            ({record.performance_bonus ? formatter.format(PerhourChange): formatter.format(NUMBER.ZERO)}/hr)</span>}
                                        {record.bonus_split_type === 'by_wage' && <span className='approve-bonus-text'>
                                            ({record.performance_bonus ? parseFloat(PercenatgeChange.toString()).toFixed(NUMBER.TWO): '0'}%)
                                            {record.performance_bonus ? <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                                            <path d="M1 6.5L6 1.5M6 1.5L11 6.5M6 1.5V13.5" stroke="#4FCA4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg> : ''}
                                            </span>}
                                        </span>
                                        </div>
                                        </td>
                                    </tr>
                                    {record.overage ? <tr>
                                         <td colSpan={2} className='budget-headers hidden-td-mobile'>Overage</td>
                                         <td data-title='Overage'>{formatter.format(record.overage)}</td>
                                        </tr>:''}
                                </tbody>
                            </table>
                    </div>
                    </TabPanel>
                    </div>
                </TabContext>
               </TabPanel>
               <TabPanel value="Forecast">
                <BonusCalculatorDetailPage record={record} maxHours={maxHours}/>
            </TabPanel>
        </TabContext>
        </>
    )
}
export default PropayActualAndTotalData;

type LabelWithTooltipProps = {
    label: string;
    tooltipTitle: string;
  }


export const LabelWithTooltip = (props:LabelWithTooltipProps) => {
    const {label, tooltipTitle,} = props;
    return(
        <Tooltip id='unique-tooltip' className='unique-tooltip' title={tooltipTitle} placement="bottom" arrow>
        <span className='fix-account'>{label}</span>
        </Tooltip>
    );
}
